import type { Client } from 'types/client';

export const calculateProjectCounts = (
  clients: Array<Client>
): {
  total: number;
  active: number;
  archived: number;
} => {
  const counts = {
    total: 0,
    active: 0,
    archived: 0,
  };

  for (const client of clients) {
    counts.active += client.active_projects_count ?? 0;
    counts.archived += client.archived_projects_count ?? 0;
  }

  counts.total = counts.active + counts.archived;

  return counts;
};
